














import { Vue, Component } from 'vue-property-decorator';
import { Tab, Tabs } from 'vant';
import * as config from './config';
import { getVoteList } from '@/api/api';
import VoteList from './components/VoteList.vue';
Vue.use(Tab).use(Tabs);
@Component({
  components: {
    VoteList,
  },
})
export default class First extends Vue {
  option = config.OPTHINES;
  listType: number | string = 1;
  tabArr: any[] = [
    {
      text: '十大康养产业领先机构',
      type: 1,
    },
    {
      text: '十大康养产业领先人物',
      type: 2,
    },
  ];
  handleClick(item: any) {
    this.listType = item + 1;
  }
  enterDetailPage(id: any) {
    this.$router.push({
      path: 'detail',
      query: {
        id,
      },
    });
  }
}
